import { createSlice } from "@reduxjs/toolkit";
import { getAssemblyList } from "../../reduxApi/admin/AssemblyReduxApi";
const AssemblySlice = createSlice({
    name: "Assembly",
    initialState: {
        status: "idle",
        isFiltered: false,
        assembly: [],
    },

    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },

        deleteAssemblyAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.assembly.findIndex(
                    (item) => item.ROWID === id
                );

                if (index !== -1) {
                    state.assembly.splice(index, 1);
                }
            });
        },

        updateAssemblyAction: (state, action) => {
            const { ROWID, payload } = action.payload;
            const index = state.assembly.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );
            if (index !== -1) {
                state.assembly[index] = {
                    ...state.assembly[index],
                    ...payload
                };
            }

        },

        addAssemblyAction: (state, action) => {
            state.assembly.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAssemblyList.pending, (state) => {
                state.status = "pending";
            })

            .addCase(getAssemblyList.fulfilled, (state, action) => {
                state.status = "fulfilled";
                console.log("Assembly  action", action)
                state.assembly = action.payload?.data
            })

            .addCase(getAssemblyList.rejected, (state) => {
                state.status = "rejected";
            });
    },
});

export const {
    deleteAssemblyAction,
    updateAssemblyAction,
    addAssemblyAction,
    setFilteredStatus,
    clearFilters,
} = AssemblySlice.actions;

export default AssemblySlice.reducer;